"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomFields = void 0;
const base_1 = require("../../../base");
exports.CustomFields = {
    list: (0, base_1.declare)({
        method: 'get',
        path: '/sysadmin/workspaces/:workspaceId/customFields',
    }).as(),
    Values: {
        list: (0, base_1.declare)({
            method: 'get',
            path: '/sysadmin/workspaces/:workspaceId/customFields/:customFieldId/values',
        }).as(),
    },
};
//# sourceMappingURL=CustomFields.js.map